export default __webpack_public_path__ + "img/bg_about_hero-864c907afd4f3eff3234d7e403c77447.png";